<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="hasVer" slot-scope="prop">
        <el-checkbox label="待我处理" v-model="prop.form.hasVer" />
      </div>
      <div slot="driverLicenseExpired" slot-scope="prop">
        <el-checkbox label="即将过期" v-model="prop.form.driverLicenseExpired" />
      </div>
      <div slot="qcCertiExpired" slot-scope="prop">
        <el-checkbox label="即将过期" v-model="prop.form.qcCertiExpired" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
  selectSysStaticDataByCodeType,
} from 'api';
import {getAddressOptions} from '@qx/utils';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        carUserTypeOptions: [], // 司机类型
        orgIdOptions: [], // 归属部门
        stateOptions: [], // 认证状态 USER_STATE
        entryStateOptions: [], // 在职状态 DRIVER_ENTRY_STATE
        form: [
          {
            label: '',
            value: 'state',
            type: 'radio',
            default: '-1',
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          { // 司机账号
            label: '司机账号',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入司机账号',
          },
          { // 司机名称
            label: '司机名称',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入司机名称',
          },
          // { // 审核状态
          //   label: '审核状态',
          //   value: 'hasVer',
          //   slot: true,
          //   default: false,
          // },
          { // 驾驶证
            label: '驾驶证',
            value: 'driverLicenseExpired',
            slot: true,
            default: false,
            // options: [
            //   {
            //     label: '正常',
            //     value: false,
            //   },
            //   {
            //     label: '即将过期',
            //     value: true,
            //   },
            // ],
          },
          { // 从业资格证
            label: '从业资格证',
            value: 'qcCertiExpired',
            slot: true,
            default: false,
            // options: [
            //   {
            //     label: '正常',
            //     value: false,
            //   },
            //   {
            //     label: '即将过期',
            //     value: true,
            //   },
            // ],
          },
          { // 司机类型
            label: '司机类型',
            value: 'carUserType',
            type: 'select',
            placeholder: '请选择司机类型',
            default: -1,
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择归属部门',
          },
          { // 归属车队
            label: '归属车队',
            value: 'attachTenantName',
            type: 'input',
            placeholder: '请输入归属车队',
          },
          { // 车队联系人
            label: '车队联系人',
            value: 'attachTennantLinkman',
            type: 'input',
            placeholder: '请输入车队联系人',
          },
          { // 司机账号
            label: '车队电话',
            value: 'attachTennantLinkPhone',
            type: 'input',
            placeholder: '请输入车队电话',
          },
          { // 在职状态
            label: '在职状态',
            value: 'entryState',
            type: 'select',
            default: -1,
            placeholder: '请选择在职状态',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'DRIVER_TYPE,USER_STATE,DRIVER_ENTRY_STATE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    const stateOptions = await selectSysStaticDataByCodeType({
      codeType: 'TENANT_USER_REL.STATE',
      hasAll: true,
    });
    this.searchBoxData.carUserTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.stateOptions = stateOptions;
    this.searchBoxData.entryStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(2),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...((await getDepartmentAllList({
        isArchive: true,
      })) || []),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
